export default __webpack_public_path__ + "static/media/gabriel.b660fad2.png";